import _ from "ES/lib/lodash";
import React from "ES/lib/react";
import esUtils from "ES/utils/esUtils";
import getLedgerData from "./getLedgerData";

let FeeLine = function (props) {
    let {fee, description} = props;
    let amt = "$" + _.padLeft(esUtils.format_number(fee, 2), 11, " ");
    return <div>
        <div style={{whiteSpace: "pre-wrap", fontFamily: "monospace", float: "left"}}>
            {amt + " "}
        </div>
        <div style={{overflow: "hidden"}}>
            {description}
        </div>
    </div>;
};

let PaymentLine = function (payment) {
    let amt = "$" + _.padLeft(esUtils.format_number(_.get(payment, "amount", 0.00), 2), 11, " ");
    return <div key={_.get(payment, "payment_id")}>
        <div style={{whiteSpace: "pre-wrap", fontFamily: "monospace", float: "left"}}>
            {amt + " "}
        </div>
        <div style={{overflow: "hidden"}}>
            {_.get(payment, "method_text") + " payment on " + esUtils.format_date(esUtils.convertFromISO8601(_.get(payment, "created_iso8601", null)), "mmm dd, yyyy")}
            {_.map(payment.flags_array, function (flag) {
                flag = flag.replace("status_", "");
                return <span key={_.get(payment, "payment_id") + flag} style={{backgroundColor: "green", color: "white", fontSize: "0.8em", padding: "1px 2px 2px 2px", marginLeft: "1em", borderRadius: "3px"}}>{flag}</span>;
            })}
        </div>
    </div>;
};


let pluckPayments = function (event) {
    let payments = {};
    _.each(_.get(event, "MPPaymentsUnmapped", {}), function (payment) {
        payments[payment.id] = payment;
    });

    return payments;
};

export default function (props) {
    let {fees, grand_total, fee_speaking, fee_travel, fee_materials} = getLedgerData(props);
    let display_payments = _.get(props, 'display_payments', false);
    let payments = pluckPayments(props.event);
    let payment_body = null;

    if (display_payments) {
        if (_.isEmpty(payments)) {
            payment_body = <p className="text-muted">- the client has not made a payment yet -</p>;
        } else {
            payment_body = _.map(payments, function (payment, payment_id) {
                return PaymentLine(payment);
            });
        }
        payment_body = <div style={{color: "green", marginBottom: "1em"}}>
            <b>payments made by client</b>
            {payment_body}
        </div>;
    }

    let payout_body = _.map(_.groupBy(fees, "due"), function (fees, group) {
        let total = _.reduce(fees, function (sum, f) {
            return sum + f.fee;
        }, 0);
        return <div key={group} style={{marginBottom: "1em"}}>
            <b>{group}</b>
            {_.map(fees, function (f, i) {
                return <FeeLine key={i} fee={f.fee} description={f.description}/>;
            })}
            <hr style={{margin: 0, borderColor: "#ccc"}}/>
            <div className="text-muted">
                <FeeLine fee={total} description="to you *"/>
            </div>
        </div>;
    });

    let contractedamounts_body =
            <div style={{marginBottom: "1em"}}>
                <b>contracted fees</b>
                <FeeLine key="contractspeaking" fee={fee_speaking} description="speaking fee"/>
                <FeeLine key="contracttravel" fee={fee_travel} description="travel"/>
                <FeeLine key="contractmaterials" fee={fee_materials} description="materials / other"/>
            </div>;


    return <div>
        <div style={{
            borderRadius: ".5em",
            background: "#eee",
            border: "1px solid #aaa",
            padding: "1em"
        }}>
            {contractedamounts_body}
            {payment_body}
            {payout_body}
            <hr style={{margin: 0, borderColor: "black"}}/>
            <FeeLine fee={grand_total} description="TOTAL to you *"/>
            <div className="text-muted" style={{marginTop: "1em"}}>
                * less card processing costs up to 3%.
            </div>
        </div>
    </div>;
}



// WEBPACK FOOTER //
// ./src/components/marketplace/MyLeadsTab/Ledger.js